<template>
  <div ref="element" :class="stickClass">
    <slot></slot>
  </div>
</template>

<script>
import { makeId } from '../../../lib/lib'
// import stick_in_parent from 'sticky-kit'
import constants from '../../../lib/constants'
import jquery from 'jquery'

export default {
  data() {
    return {
      sticky: false,
      id: `sticky-${makeId()}`,
    }
  },
  computed:{
    stickClass(){
      return this.sticky ? 'b-sidenav-sticky': ''
    }
  },
  mounted() {
    this.assigntoViewports()
    window.addEventListener('resize', () => {
      this.assigntoViewports()
    })
  },
  beforeUnmount() {
    this.destroySticky()
  },
  methods: {
    assigntoViewports() {
      if (constants.is === 'desktop') {        
        this.createSticky()
        
      } else {
        this.destroySticky()
      }
    },
    createSticky() {
      const height = jquery(this.$refs.element).outerHeight()
      const top = jquery(this.$refs.element).position().top
      const windH = constants.windH

      if(height + top < windH){
        this.sticky = true
      } else {
        this.destroySticky()
      }
    },
    destroySticky() {
      this.sticky = false
    },
  }
}
</script>
